<template>
  <div>

    <el-carousel height="52.66667vw" indicator-position="none">
      <!-- :style="'backgroundImage'+':'+ url+'('+imgurl + item.pic+')'" -->
          <el-carousel-item v-for="item, index in list" :key="index">
          
            <el-image style="height: 100%; width: 100%;"  class="bl imgscale" :src="imgurl + item.pic"></el-image>
          </el-carousel-item>
      </el-carousel>
 


    <el-row class="home1">

      <el-col :xs="0" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="imgbox">
          <el-image class="xues1 imgscale" ref="xues1" :class="{animated:true,fadeInUp: testShow1}" :src="require('@/assets/xues2.png')"></el-image>
          <el-image class="xues2 imgscale" ref="xues2" :class="{animated:true,fadeInDown: testShow2}" :src="require('@/assets/xues1.png')"></el-image>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <div class="jiesao" >
          <h6>关于希望之星</h6>
          <p>About the star of hope</p>
          <span>河南希望之星服饰有限公司是一家集原材料批发、设计、生产、销售为一体的服装企业，原厂址在新郑市龙湖梅山路88号。现在息县陈棚乡扩</span>
          <router-link to="/about">
            <el-button size="mini" style="">Stared</el-button>
          </router-link>
          
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="home2">
          <div class="title">
            <h6>我们的产品</h6>
            <p>Our products</p>
          </div>
          <div class="mainbox">
            <!-- @click="currentInfo(index)"   -->
            <el-card body-style="{ 'padding': 'undefined' }" shadow="hover" 
             class="box-card imgscale" v-for="it,i in child" :key="i" ref="card" :class="{animated:true,zoomIn: testShow3}" @mouseenter.native="isid = it.id"  @mouseleave.native="isid = null">
             
              <div class="cardnav">
                <el-image class="xuesheng" :src="imgurl + it.pic"></el-image>
                
              </div>
              <div class="cardcentent">
                <h6>{{ it.title }}</h6>
                <p> {{ it.subtitle || 'Middle school uniforms'}}</p>

                <transition name="el-zoom-in-top">
                   <router-link to="/classify" v-if="isid == it.id">
                    <el-button class="butt" size="medium">Learn More</el-button>
                  </router-link>
                </transition>
                  
                
                
              </div>

            </el-card>
            


          </div>

        </div>
      </el-col>

    </el-row>


    <el-row>
      <el-col :xs="0" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="home3">
          <div class="lefttext">
            <h6>我们有五大优势</h6>
            <p>We have FIVE advantages</p>
          </div>
          <div class="rightimg">
           
            <el-image class="dian" :src="require('@/assets/dian.png')"></el-image>
            <div class="text">
              <h5 style="">我们有五大优势</h5>
              <div class="you">
                <p>1.面料研发 面料生产 服装加工 产品安全</p>
                <el-image class="dui" :src="require('@/assets/dui.png')"></el-image>
              </div>
              <div class="you">
                <p>2.希望之星校服面料研发的十大方向</p>
                <el-image class="dui" :src="require('@/assets/dui.png')"></el-image>
              </div>
              <div class="you">
                <p> 3.一站式校服生产服务供应商</p>
                <el-image class="dui" :src="require('@/assets/dui.png')"></el-image>
              </div>
              <div class="you">
                <p> 4.产品质量把控</p>
                <el-image class="dui" :src="require('@/assets/dui.png')"></el-image>
              </div>
              <div class="you">
                <p> 5.河南省市场监督管理局针对校服抽检合格报告</p>
                <el-image class="dui" :src="require('@/assets/dui.png')"></el-image>
              </div>

            </div>
          </div>

        </div>
      </el-col>

    </el-row>




  </div>
</template>
<script>
import { myMixins } from "@/utils/mixin.js";
export default {
  mixins: [myMixins],
  name: 'homeView',
  props: {
    list: Array,
    child: Array,
  },
  data() {
    return {
      testShow1:false,
      testShow2:false,
      testShow3:false,
      cardshow:false,
      isid:''
      // screenheight: document.documentElement.clientHeight - 200 + 'px',
     
    }
  },
  created() {
    // console.log(Math.min(8, 2));
  },
  methods: {
    // 鼠标移入
    handleEnter() {
      console.log('in');
    },
    // 鼠标移出
    handleLeave() {
      console.log('out');
    },
    handleSelect() {
      // console.log(key, keyPath);
     

    },
    handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        if (this.currentScroll >=  this.$refs.xues2.$el.offsetTop) {
            //当前滚动位置到达testref的时候，显示div（100作为调整用）
            this.testShow1 = true
        }
        // console.log(this.currentScroll,'视口');
        // console.log(this.$refs.xues2.$el.offsetTop,'元素');
        if (this.currentScroll >= this.$refs.xues2.$el.offsetTop) {
            //当前滚动位置到达testref的时候，显示div（100作为调整用）
            this.testShow2 = true
        }
     
        if (this.currentScroll >=  this.$refs.card[0].$el.offsetTop + 900) {
            //当前滚动位置到达testref的时候，显示div（100作为调整用）
            this.testShow3 = true
        }
        
        
    }
  }
}
</script>
<style scoped lang="less">
// --------------轮播图-----------------------
.el-carousel-item{
  background-size: 100% 100% ;
}
.bl {
    width: 100%;
    height: 100%;
  
  }
// -------------------------------------
.box1 {
  height: 1000px;
  border: 1px solid red;
  position: relative;

  .xues1 {
    position: absolute;
    left: calc(50% - 100px);
    top: calc(50% - 200px);
    width: 500px;
    height: 360px;
    border-radius: 20px;

  }

  .xues2 {
    position: absolute;
    left: calc(50% - 280px);
    top: calc(50% - 40px);
    width: 500px;
    height: 360px;
    border-radius: 20px;
  }
}

.imgbox {
  height: 1000px;
  position: relative;

  .xues1 {
    position: absolute;
    left: calc(50% - 100px);
    top: calc(50% - 200px);
    width: 500px;
    height: 360px;
    border-radius: 20px;

  }

  .xues2 {
    position: absolute;
    left: calc(50% - 280px);
    top: calc(50% - 40px);
    width: 500px;
    height: 360px;
    border-radius: 20px;
  }
}

.jiesao {
  height: 1080px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 100px;

  // height: 200px;
  // border: 1px solid red;
  h6 {
    margin-top: 46px;
    text-align: left;
    font-size: 46px;

  }

  p {
    text-align: left;
    margin: 10px 0;
    font-size: 46px;
    color: #585F5E;
    // font-family: "pfcat";
    font-family: "微软雅黑";
    font-weight: 200;
    display: inline;
  }

  span {
    text-align: left;
    // padding-right: 100px;
    font-size: 22px;
    color: #585F5E;
  }

  .el-button {
    width: 190px;
    height: 56px;
    margin-top: 40px;
    background-color: #016F62;
    color: #fff;
  }
}

.home1 {
  background-image: url(../assets/bj1.png);
  background-size: 100% 100%;
}

// -----------------------------------------
.home2 {
  background-image: url(../assets/bj2.png);
  background-size: 100% 100%;
  height: 800px;
  .title {
    padding-top: 100px;
    h6 {
      font-size: 46px;
    }

    p {
      margin-top: 10px;
      font-size: 46px;
      font-family: "微软雅黑";
      font-weight: 200;
    }
  }
  ::v-deep .el-card__body .el-main{
    padding: 0 !important;
  }
  ::v-deep .el-card__body{
    padding: 0 !important;
  }
  .mainbox {
    display: flex;
    justify-content: space-around;
    margin-top: 50px;
    .box-card {
      width: 450px;
      border-radius: 50px;
      .cardnav {
        height: 100px;
        background-color: #016F62;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .xuesheng {
          width:120px;
          height: 90px;
        }

      }

      .cardcentent {
        // min-height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h6 {
          font-size: 26px;
          margin-top: 20px;
        }

        p {
          margin: 10px 0 40px 0;
          font-size: 26px;
          width: 50%;
        }
       
        .el-button{
          margin-top: 20px;
          border-color:#016F62;
          color:#016F62;
          margin-bottom: 50px;
        }
        
      }
    }
    
  }
}

// ----------------------------
.home3 {
  padding-top: 30px;
  background-image: url(../assets/bj2.png);
  background-size: 100% 100%;
  height: 1000px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .lefttext {
    // margin-top: 100px;
    width: 30%;
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h6 {
      width: 400px;
      font-size: 46px;
    }

    p {
      margin-top: 10px;
      width: 400px;
      font-size: 46px;
    }
  }

  .rightimg {
    height: 700px;
    width: 60%;
    background-image: url(../assets/xuesheng2.png);
    background-size: 100% 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .dian {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 0;
      left: 0;
    }

    .el-button {
      position: absolute;
      bottom: -10px;
      left: 200px;
    }

    .text {
      margin-right: 30px;
      display: flex;
      flex-direction: column;

      width: 50%;
      color: #ffffff;

      h5 {
        font-size: 46px;
        text-align: left;
      }

      .you {
        margin-top: 30px;
        padding-right: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
          font-size: 22px;
          margin-right: 26px
        }

      }

      .dui {
        width: 40px;
        height: 40px;
      }

    }

  }
}</style>     